module.exports = __webpack_public_path__ + "static/media/eleaguemajor.efe553ee.jpg";